import * as React from "react";
import { Controller } from "react-hook-form";
import { AutocompleteRenderInputParams } from "@mui/material/Autocomplete/Autocomplete";
import { useTranslation } from "react-i18next";
import { FormHelperText } from "@mui/material";
import AsyncAutocomplete from "./AsyncAutocomplete";


interface FormAsyncAutocompleteProps {
    name: string,
    control: any,
    props: {
        callback: (search: string) => Promise<any>,
        renderInput: (params: AutocompleteRenderInputParams) => React.ReactNode,
        disabled?: boolean
        multiselect?: boolean
        initialValues?: boolean
        onSelect?: (value: any) => void
        getOptionLabel?: (option: any) => string
    }
}


export const FormAsyncAutocomplete = ({ name, control, props }: FormAsyncAutocompleteProps) => {

    const { t } = useTranslation('mobilityvoucher');

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { name, value, onChange }, fieldState: { error } }) =>
                <>
                    <AsyncAutocomplete
                        {...props}
                        value={value || null}
                        onChange={value => {
                            onChange(value ? value : '')
                            if (props.onSelect != null) {
                                props.onSelect(value ? value : '')
                            }
                        }}

                    />
                    <FormHelperText
                        error={!!error}
                        id="my-helper-text">{(error && error.type === 'required' && t('forms.required-field', { label: name })) || error?.message}
                    </FormHelperText>
                </>
            }
        />
    );
}

export default FormAsyncAutocomplete;